import React from "react";

export default function Loader({
  size = "md",
  color = "primary",
  text = "",
  className = "",
  variant = "spinner", // spinner, dots, pulse
}) {
  const sizeClasses = {
    sm: "h-4 w-4",
    md: "h-8 w-8",
    lg: "h-12 w-12",
    xl: "h-16 w-16",
  };

  const colorClasses = {
    primary: "border-[#8B313A]",
    white: "border-white",
    gray: "border-gray-500",
    red: "border-red-500",
    blue: "border-blue-500",
  };

  const textColorClasses = {
    primary: "text-gray-600",
    white: "text-white",
    gray: "text-gray-500",
    red: "text-red-600",
    blue: "text-blue-600",
  };

  const renderSpinner = () => (
    <div
      className={`animate-spin rounded-full border-b-2 ${sizeClasses[size]} ${colorClasses[color]}`}
    />
  );

  const renderDots = () => (
    <div className="flex space-x-1">
      {[0, 1, 2].map((i) => (
        <div
          key={i}
          className={`${
            sizeClasses[size]
          } rounded-full animate-pulse ${colorClasses[color].replace(
            "border-",
            "bg-"
          )}`}
          style={{
            animationDelay: `${i * 0.2}s`,
            animationDuration: "1s",
          }}
        />
      ))}
    </div>
  );

  const renderPulse = () => (
    <div
      className={`${
        sizeClasses[size]
      } rounded-full animate-pulse ${colorClasses[color].replace(
        "border-",
        "bg-"
      )}`}
    />
  );

  const renderLoader = () => {
    switch (variant) {
      case "dots":
        return renderDots();
      case "pulse":
        return renderPulse();
      default:
        return renderSpinner();
    }
  };

  return (
    <div className={`flex flex-col items-center justify-center ${className}`}>
      {renderLoader()}
      {text && (
        <p className={`mt-2 text-sm ${textColorClasses[color]}`}>{text}</p>
      )}
    </div>
  );
}
